module.exports = __webpack_public_path__ + "img/robot3.png";